// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-match-referees-payment-resume.modal {
    background-color: var(--body-background-color);
}

.league-match-referees-payment-resume__container {
    padding: var(--space-x2) calc( var(--space-x3) + var(--space-x3) - var(--space-half)) var(--space-x3) calc( var(--space-x3) + var(--space-x3) - var(--space-half));
}

.league-match-referees-payment__match-info__title.baloa-table-column {
    color: var(--primary-very-dark-color);
}

.league-match-referees-payment-resume .modal__container {
    max-width: 821px;
    width: 821px;
    padding: 0;
}

.league-match-referees-payment-resume__match-info__team {
    display: flex;
    align-items: center;
}

.league-match-referees-payment-resume__match-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--new-gray-background-color);
    border-radius: var(--space-quarter);
    padding: var(--space-half) calc( var(--space-x3) + var(--space-and-half) );
    margin: var(--space-x2) 0;
}

.league-match-referees-payment-resume__match-info__title.baloa-table-column {
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space);
}

.league-match-referees-payment-resume__match-info__teams {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
.league-match-referees-payment-resume__match-info__teams .baloa-table-column {
    color: var(--basic-gray-color);
}
.league-match-referees-payment-resume__match-info__teams .league-match-referees-payment-resume__match-info__team:first-of-type .league-match-referees-payment-resume__match-info__team-name {
    margin-left: var(--space-half-quarter);
}

.league-match-referees-payment-resume__match-info__teams .league-match-referees-payment-resume__match-info__team:last-of-type .league-match-referees-payment-resume__match-info__team-name {
    margin-right: var(--space-half-quarter);
}

.league-match-referees-payment-resume__match-info__team-img span.icon-ball {
    border-radius: 50%;
    color: var(--white-color);
    font-size: 24px;
    padding: 4px;
}

.league-match-referees-payment-resume__match-info__team-img img {
    border-radius: 50%;
    width: var(--space-x2);
    height: var(--space-x2);
}

.league-match-referees-payment-resume__match-info__team-img {
    display: flex;
}

.league-match-referees-payment-resume__match-info__team-name .baloa-names {
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space-quarter);
}

.league-match-referees-payment-resume__match-info__team-name .baloa-username {
    color: var(--primary-dark-color);
}

.league-match-referees-payment-resume__reference .baloa-table,
.league-match-referees-payment-resume__tournament-reference .baloa-table,
.league-match-referees-payment-resume__team-pays__container .baloa-table {
    color: var(--basic-gray-color);
    margin-bottom: var(--space-half);
}

.league-match-referees-payment-resume__reference .baloa-hyperlink-2 {
    color: var(--primary-very-dark-color);
}

.league-match-referees-payment-resume__tournament-name,
.league-match-referees-payment-resume__team-name {
    margin-left: var(--space-half);
}

.league-match-referees-payment-resume__tournament-name .baloa-hyperlink-2,
.league-match-referees-payment-resume__team-name .baloa-hyperlink-2 {
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space-half);
}

.league-match-referees-payment-resume__tournament-info,
.league-match-referees-payment-resume__team-info {
    display: flex;
    align-items: center;
}

.league-match-referees-payment-resume__tournament-name__labels {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.league-match-referees-payment-resume__tournament-name__labels .baloa-mini {
    font-size: 11px;
    line-height: 13px;
    color: var(--primary-dark-color);
    padding: var(--space-quarter) var(--space-half);
    background-color: var(--new-grey-light-background-color);
    border-radius: var(--space-and-half);
    border: 1px solid var(--new-grey-border-color);
    white-space: nowrap;
}

.league-match-referees-payment-resume__tournament-name__labels .baloa-mini:nth-of-type(2) {
    margin: 0 var(--space-quarter);
}

.league-match-referees-payment-resume__reference-container {
    display: flex;
    justify-content: space-between;
}

.league-match-referees-payment-resume__tournament-img .icon-ball,
.league-match-referees-payment-resume__team-img .icon-ball {
    border-radius: 50%;
    color: var(--white-color);
    font-size: 24px;
    padding: 4px;   
}

.league-match-referees-payment-resume__tournament-img img,
.league-match-referees-payment-resume__team-img img {
    border-radius: 50%;
    width: var(--space-x2);
    height: var(--space-x2);
}

.league-match-referees-payment-resume__team-pays__container {
    margin: var(--space) 0 var(--space-x2) 0;
}

.league-match-referees-payment-resume__discount-code__input {
    display: flex;
    align-items: center;
}

.league-match-referees-payment-resume__discount-code__input input {
    padding: var(--space-half) var(--space-half-quarter);
}

.league-match-referees-payment-resume__discount-code__input .button {
    margin-left: var(--space-half);
    padding: var(--space-half) var(--space-half-quarter);
}

.league-match-referees-payment-resume__discount-code__input input[type="text"] {
    padding: var(--space-half) var(--space-half-quarter);
    border-radius: var(--space-quarter);
    border: 1px solid var(--new-gray-background-color);
    min-width: 248px;
}

.league-match-referees-payment-resume__discount-code__input input:focus { 
    outline: none;
 }

.league-match-referees-payment-resume__discount-code .baloa-table-column {
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space-quarter);
}

.league-match-referees-payment-resume__total-amount .baloa-table {
    color: var(--basic-gray-color);
    margin-bottom: var(--space-half);
    font-weight: var(--font-medium);
}

.league-match-referees-payment-resume__total-amount .baloa-hyperlink-2 {
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space-half);
    font-weight: var(--font-medium);
}

.league-match-referees-payment-resume__total-amount {
    margin-top: var(--space);
}

.league-match-referees-payment-resume__buttons-action {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: var(--space);
    border-top: 1px solid var(--new-input-background-color);
}

.league-match-referees-payment-resume__buttons-action .secondary-button {
    margin-right: var(--space-and-half);
    border: none;
    color: var(--primary-dark-color);
}

.league-match-referees-payment-resume__buttons-action .secondary-button:hover {
    background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-match-referees-payment-resume-modal/LeagueMatchRefereesPaymentResumeModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;AAClD;;AAEA;IACI,kKAAkK;AACtK;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kDAAkD;IAClD,mCAAmC;IACnC,0EAA0E;IAC1E,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;AACA;IACI,8BAA8B;AAClC;AACA;IACI,sCAAsC;AAC1C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;;IAGI,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;;IAEI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,+CAA+C;IAC/C,wDAAwD;IACxD,oCAAoC;IACpC,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,8BAA8B;IAC9B,oDAAoD;AACxD;;AAEA;IACI,oDAAoD;IACpD,mCAAmC;IACnC,kDAAkD;IAClD,gBAAgB;AACpB;;AAEA;IACI,aAAa;CAChB;;AAED;IACI,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,uDAAuD;AAC3D;;AAEA;IACI,mCAAmC;IACnC,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".league-match-referees-payment-resume.modal {\n    background-color: var(--body-background-color);\n}\n\n.league-match-referees-payment-resume__container {\n    padding: var(--space-x2) calc( var(--space-x3) + var(--space-x3) - var(--space-half)) var(--space-x3) calc( var(--space-x3) + var(--space-x3) - var(--space-half));\n}\n\n.league-match-referees-payment__match-info__title.baloa-table-column {\n    color: var(--primary-very-dark-color);\n}\n\n.league-match-referees-payment-resume .modal__container {\n    max-width: 821px;\n    width: 821px;\n    padding: 0;\n}\n\n.league-match-referees-payment-resume__match-info__team {\n    display: flex;\n    align-items: center;\n}\n\n.league-match-referees-payment-resume__match-info {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: var(--space-quarter);\n    padding: var(--space-half) calc( var(--space-x3) + var(--space-and-half) );\n    margin: var(--space-x2) 0;\n}\n\n.league-match-referees-payment-resume__match-info__title.baloa-table-column {\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space);\n}\n\n.league-match-referees-payment-resume__match-info__teams {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n.league-match-referees-payment-resume__match-info__teams .baloa-table-column {\n    color: var(--basic-gray-color);\n}\n.league-match-referees-payment-resume__match-info__teams .league-match-referees-payment-resume__match-info__team:first-of-type .league-match-referees-payment-resume__match-info__team-name {\n    margin-left: var(--space-half-quarter);\n}\n\n.league-match-referees-payment-resume__match-info__teams .league-match-referees-payment-resume__match-info__team:last-of-type .league-match-referees-payment-resume__match-info__team-name {\n    margin-right: var(--space-half-quarter);\n}\n\n.league-match-referees-payment-resume__match-info__team-img span.icon-ball {\n    border-radius: 50%;\n    color: var(--white-color);\n    font-size: 24px;\n    padding: 4px;\n}\n\n.league-match-referees-payment-resume__match-info__team-img img {\n    border-radius: 50%;\n    width: var(--space-x2);\n    height: var(--space-x2);\n}\n\n.league-match-referees-payment-resume__match-info__team-img {\n    display: flex;\n}\n\n.league-match-referees-payment-resume__match-info__team-name .baloa-names {\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space-quarter);\n}\n\n.league-match-referees-payment-resume__match-info__team-name .baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.league-match-referees-payment-resume__reference .baloa-table,\n.league-match-referees-payment-resume__tournament-reference .baloa-table,\n.league-match-referees-payment-resume__team-pays__container .baloa-table {\n    color: var(--basic-gray-color);\n    margin-bottom: var(--space-half);\n}\n\n.league-match-referees-payment-resume__reference .baloa-hyperlink-2 {\n    color: var(--primary-very-dark-color);\n}\n\n.league-match-referees-payment-resume__tournament-name,\n.league-match-referees-payment-resume__team-name {\n    margin-left: var(--space-half);\n}\n\n.league-match-referees-payment-resume__tournament-name .baloa-hyperlink-2,\n.league-match-referees-payment-resume__team-name .baloa-hyperlink-2 {\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space-half);\n}\n\n.league-match-referees-payment-resume__tournament-info,\n.league-match-referees-payment-resume__team-info {\n    display: flex;\n    align-items: center;\n}\n\n.league-match-referees-payment-resume__tournament-name__labels {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.league-match-referees-payment-resume__tournament-name__labels .baloa-mini {\n    font-size: 11px;\n    line-height: 13px;\n    color: var(--primary-dark-color);\n    padding: var(--space-quarter) var(--space-half);\n    background-color: var(--new-grey-light-background-color);\n    border-radius: var(--space-and-half);\n    border: 1px solid var(--new-grey-border-color);\n    white-space: nowrap;\n}\n\n.league-match-referees-payment-resume__tournament-name__labels .baloa-mini:nth-of-type(2) {\n    margin: 0 var(--space-quarter);\n}\n\n.league-match-referees-payment-resume__reference-container {\n    display: flex;\n    justify-content: space-between;\n}\n\n.league-match-referees-payment-resume__tournament-img .icon-ball,\n.league-match-referees-payment-resume__team-img .icon-ball {\n    border-radius: 50%;\n    color: var(--white-color);\n    font-size: 24px;\n    padding: 4px;   \n}\n\n.league-match-referees-payment-resume__tournament-img img,\n.league-match-referees-payment-resume__team-img img {\n    border-radius: 50%;\n    width: var(--space-x2);\n    height: var(--space-x2);\n}\n\n.league-match-referees-payment-resume__team-pays__container {\n    margin: var(--space) 0 var(--space-x2) 0;\n}\n\n.league-match-referees-payment-resume__discount-code__input {\n    display: flex;\n    align-items: center;\n}\n\n.league-match-referees-payment-resume__discount-code__input input {\n    padding: var(--space-half) var(--space-half-quarter);\n}\n\n.league-match-referees-payment-resume__discount-code__input .button {\n    margin-left: var(--space-half);\n    padding: var(--space-half) var(--space-half-quarter);\n}\n\n.league-match-referees-payment-resume__discount-code__input input[type=\"text\"] {\n    padding: var(--space-half) var(--space-half-quarter);\n    border-radius: var(--space-quarter);\n    border: 1px solid var(--new-gray-background-color);\n    min-width: 248px;\n}\n\n.league-match-referees-payment-resume__discount-code__input input:focus { \n    outline: none;\n }\n\n.league-match-referees-payment-resume__discount-code .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space-quarter);\n}\n\n.league-match-referees-payment-resume__total-amount .baloa-table {\n    color: var(--basic-gray-color);\n    margin-bottom: var(--space-half);\n    font-weight: var(--font-medium);\n}\n\n.league-match-referees-payment-resume__total-amount .baloa-hyperlink-2 {\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space-half);\n    font-weight: var(--font-medium);\n}\n\n.league-match-referees-payment-resume__total-amount {\n    margin-top: var(--space);\n}\n\n.league-match-referees-payment-resume__buttons-action {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    padding: var(--space);\n    border-top: 1px solid var(--new-input-background-color);\n}\n\n.league-match-referees-payment-resume__buttons-action .secondary-button {\n    margin-right: var(--space-and-half);\n    border: none;\n    color: var(--primary-dark-color);\n}\n\n.league-match-referees-payment-resume__buttons-action .secondary-button:hover {\n    background-color: transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
